import { useMutation } from '@tanstack/react-query';

import { exportPartyToDias } from 'wg-api-sdk';

import wgApi from '@/lib/api/wgApi';

export default function useExportPartyToDias() {
  return useMutation({
    mutationFn: ({ partyId }: { partyId: string }) =>
      exportPartyToDias(
        {
          params: {
            path: { party_id: partyId },
            query: {},
          },
        },
        wgApi,
      ),
  });
}
